import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { Home, LogOut } from "lucide-react";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const isHome = location.pathname === "/";

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 md:hidden select-none" style={{touchAction: "manipulation"}} data-testid="bottom-nav">
      <div className="flex items-center justify-around py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        <button
          onClick={() => navigate("/")}
          className={`flex flex-col items-center gap-0.5 px-6 py-1.5 rounded-lg transition-colors ${
            isHome ? "text-slate-900" : "text-slate-500"
          }`}
          data-testid="bottom-nav-home"
        >
          <Home className="w-5 h-5" />
          <span className="text-xs font-medium">Avaleht</span>
        </button>
        <button
          onClick={logout}
          className="flex flex-col items-center gap-0.5 px-6 py-1.5 rounded-lg text-slate-500 transition-colors"
          data-testid="bottom-nav-logout"
        >
          <LogOut className="w-5 h-5" />
          <span className="text-xs font-medium">Logi välja</span>
        </button>
      </div>
    </nav>
  );
}
